import { PaymentSuccess } from "../pages/PaymentSuccess";

export default PaymentSuccessimport { PaymentSuccess } from "../pages/PaymentSuccess";

export default PaymentSuccess